import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Home as HomeIcon } from 'lucide-react';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const looksLikeAsset = location.pathname.endsWith('.html');

  useEffect(() => {
    document.title = 'Page Not Found — Pradeepta Dey';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white py-20 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-sm uppercase tracking-widest text-gray-500 dark:text-gray-400 mb-4">
          404
        </p>
        <h1 className="text-4xl md:text-5xl font-light mb-6 leading-tight">
          Page Not Found
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-10">
          We couldn't find <code className="font-mono">{location.pathname}</code>.
        </p>

        {looksLikeAsset && (
          <p className="text-sm text-gray-500 dark:text-gray-500 mb-10 max-w-xl mx-auto">
            This looks like a static asset that didn't load. Try a hard reload
            (Cmd-Shift-R / Ctrl-Shift-R), or it may have been moved — check the
            project page for the current link.
          </p>
        )}

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button onClick={() => navigate('/')} variant="default" className="gap-2">
            <HomeIcon size={16} />
            Back to Home
          </Button>
          <Button
            onClick={() => navigate('/projects')}
            variant="outline"
            className="gap-2"
          >
            <ArrowLeft size={16} />
            Back to Projects
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
